import { RefObject, useEffect } from 'react'

function addOverflowHidden() {
  document.body.classList.add('overflowHidden')
  document.body.classList.remove('overflowUnset')
}

function resetOverflow() {
  document.body.classList.add('overflowUnset')
  document.body.classList.remove('overflowHidden')
}

const useLockBodyScroll = (freeze: boolean, contentRef?: RefObject<HTMLElement>) => {
  useEffect(() => {
    if (freeze) {
      addOverflowHidden()
    } else {
      resetOverflow()
    }

    let preventScrollOutsideModal: ((e: TouchEvent) => void) | undefined

    if (freeze && contentRef) {
      preventScrollOutsideModal = (e: TouchEvent) => {
        if (contentRef.current && !contentRef.current.contains(e.target as Node)) {
          e.preventDefault()
        }
      }
      document.addEventListener('touchmove', preventScrollOutsideModal, { passive: false })
    }

    return () => {
      resetOverflow()
      if (preventScrollOutsideModal) {
        document.removeEventListener('touchmove', preventScrollOutsideModal)
      }
    }
  }, [freeze, contentRef])
}

export default useLockBodyScroll
